import * as React from 'react';
import { connect } from 'react-redux';
import { AppConstants } from '../../constants/AppConstants';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { Route, Link, Switch, Redirect } from "react-router-dom";
import CategorieList from './categorieProdottoList.jsx';
import CreateCategoria from './categoriaProdottoCreate.jsx'
import CategoriaDetails from './categoriaDetails.jsx'


class CategorieMasterPage extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CategorieMasterPage.jsx] ';
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="mt-3" >
                <Switch>
                    <Redirect exact="true" from="/categorie" to="/categorie/list" />
                    <Route path="/categorie/list" component={CategorieList} />
                    <Route path="/categorie/create" component={CreateCategoria} />
                    <Route path="/categorie/details" component={CategoriaDetails} />

                </Switch>
            </div>
        );
    }
};


function mapStateToProps(state, ownProps) {
    return {
        deviceSize: state.app.deviceSize,
        changeURL: state.app.changeURL,
        currentURL: ownProps.location.pathname
    };
};


export default connect(mapStateToProps)(CategorieMasterPage);